import LocalizedStrings from 'react-localization';

import EN from './en.json';
import TR from './tr.json';

const lang = new LocalizedStrings({ EN, TR });

export default lang;



// WEBPACK FOOTER //
// ./src/assets/lang/index.js